export default function getLinkAttribs(href, contentId, isEmbedded, isWebEmbed) {
  if (isEmbedded && contentId && !isWebEmbed) {
    return {
      deviceUrl: `nbcnews://item/${contentId}`,
    };
  }

  if (isWebEmbed) {
    return {
      target: '_parent',
      href,
    };
  }

  return {
    href,
  };
}
